
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-lg z-50 font-nunito">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-800 font-nunito">
              Dépannage Urgent Électricité LASSITANCE
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('accueil')}
              className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('garanties')}
              className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              Garanties
            </button>
            <button 
              onClick={() => scrollToSection('zone')}
              className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              Zone
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-red-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              Contact
            </button>
          </nav>

          {/* Call Button */}
          <a
            href="tel:+33656847324"
            className="hidden lg:inline-flex items-center bg-red-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-phone-line mr-2"></i>
            Appeler 06 56 84 73 24
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4 pt-4">
              <button 
                onClick={() => scrollToSection('accueil')}
                className="text-gray-700 hover:text-red-600 font-medium text-left cursor-pointer transition-colors"
              >
                Accueil
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-red-600 font-medium text-left cursor-pointer transition-colors"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('garanties')}
                className="text-gray-700 hover:text-red-600 font-medium text-left cursor-pointer transition-colors"
              >
                Garanties
              </button>
              <button 
                onClick={() => scrollToSection('zone')}
                className="text-gray-700 hover:text-red-600 font-medium text-left cursor-pointer transition-colors"
              >
                Zone
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-red-600 font-medium text-left cursor-pointer transition-colors"
              >
                Contact
              </button>
              <a
                href="tel:+33656847324"
                className="inline-flex items-center bg-red-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 transition-colors w-fit whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-phone-line mr-2"></i>
                Appeler 06 56 84 73 24
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
